
interface successRatioObj{
  negative_pl:number
  positive_pl:number
  success_ratio:number
  total_calls:number
  tsl_hits:number
}

export const initSuccessRatio = (data:any)=>{

    let obj={total_calls:0,positive_pl:0,negative_pl:0,success_ratio:0,tsl_hits:0}
    obj.total_calls = data?.length;
    data?.map((item:any)=>{
    if(item?.s_status?.length > 1)
    {
        if(item?.s_status?.toUpperCase() === "TSL HIT"){
            obj.tsl_hits += 1
        }
    }
    if(item?.n_pl >= 0)
    {
     obj.positive_pl += 1
    }
    else
    {
     obj.negative_pl += 1
    }
    })
    obj.success_ratio = Number(((obj.positive_pl / obj?.total_calls)*100)?.toFixed(2));
    return obj
}

export const backdatedInitSuccessRatio = (data:any)=>{
    let obj={total_calls:0,positive_pl:0,negative_pl:0,success_ratio:0,tsl_hits:0}
    obj.total_calls = data.length;
    data.map((item:any)=>{
    if(item?.s_reason?.length > 1)
    {
        if(item?.s_reason?.toUpperCase() === "TSL HIT"){
            obj.tsl_hits += 1
        }
        
    }
    if(item?.trade_pl >= 0)
    {
     obj.positive_pl += 1
    }
    else
    {
     obj.negative_pl += 1
    }
    })
    obj.success_ratio = Number(((obj.positive_pl / obj?.total_calls)*100).toFixed(2));
    return obj
}

export const updateObj = (new_row:any,obj:successRatioObj,data:any)=>{
 let {tsl_hits,negative_pl,positive_pl,success_ratio,total_calls}:any = obj;
    const check:any=data?.map((item:any)=> item?.s_code === new_row?.s_code);
    if (check.includes(true)) {
      //new row exist in  payload
      if (new_row?.s_status?.toUpperCase() === "TSL HIT") {
        tsl_hits += 1;
      }
      if (new_row.n_pl >= 0) {
         if(positive_pl < 0){
          negative_pl += positive_pl;
         positive_pl -= positive_pl;
        
        }
        else{
         positive_pl += 1;
          negative_pl -= 1;
        }
     
      } else {
        if(negative_pl < 0){
          positive_pl += negative_pl;
          negative_pl -= negative_pl;
       
        
        }
        else{
          negative_pl += 1;
          positive_pl -= 1;
        }
     
      }
      success_ratio = Number(((positive_pl / total_calls)*100).toFixed(2));
    } 
    else {
        //new row doesn't exist in  payload
     total_calls += 1;
      if (new_row.n_pl >= 0) {
       positive_pl += 1;
      } else {
        negative_pl += 1;
      }
      success_ratio = Number((( positive_pl / total_calls)*100).toFixed(2));
      if (new_row?.s_status?.toUpperCase() === "TSL HIT") {
       tsl_hits += 1;
      }
    }
  
    return {total_calls, positive_pl, negative_pl, success_ratio, tsl_hits}; 
}
